import React from "react"
import { Link, graphql } from "gatsby"

import BlogLayout from "../components/blog-layout"
import SEO from "../components/seo"

class BlogPostTemplate extends React.Component {
  render() {
    const post = this.props.data.markdownRemark
    const tags = this.props.data.markdownRemark
    const siteTitle = this.props.data.site.siteMetadata.title
    const { previous, next } = this.props.pageContext

    return (
      <BlogLayout location={this.props.location} title={siteTitle}>
        <SEO
          title={post.frontmatter.title}
          description={post.frontmatter.description || post.excerpt}
        />
        <article>
          <header>
            <h1
              style={{
                marginBottom: 0,
              }}
            >
              {post.frontmatter.title}
            </h1>
            <p
              style={{
                display: `block`,
              }}
            >
              {post.frontmatter.date}
            </p>
          </header>
          <section dangerouslySetInnerHTML={{ __html: post.html }} />
          <hr
            style={{
            }}
          />
          {/* <footer>
            <Bio />
          </footer> */}
        </article>
        <p>I hope you found this article helpful! Hit me on Twitter <a href="https://twitter.com/peterelbaum" rel="noopener noreferrer" target="_blank">@peterelbaum</a> to share your thoughts and <Link to="/subscribe">subscribe</Link> for more articles like this.</p>
        <nav>
          <ul
            className="footer-list"
            style={{
              display: `flex`,
              flexWrap: `wrap`,
              justifyContent: `space-between`,
              listStyle: `none`,
              padding: 0,
            }}
          >
            <li>
              {previous && (
                <Link to={previous.fields.slug} rel="prev">
                  Previous: {previous.frontmatter.title}
                </Link>
              )}
            </li>
            <li className="footer-link">
              {next && (
                <Link to={next.fields.slug} rel="next">
                  Next: {next.frontmatter.title}
                </Link>
              )}
            </li>
          </ul>
        </nav>
      </BlogLayout>
    )
  }
}

export default BlogPostTemplate

export const pageQuery = graphql`
  query BlogPostBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    markdownRemark(fields: { slug: { eq: $slug } }) {
      id
      excerpt(pruneLength: 160)
      html
      frontmatter {
        title
        date(formatString: "MMMM DD, YYYY")
        description
      }
    }
  }
`
